var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 17.224 12.566"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.928 9.522L15.076.374A1.212 1.212 0 0115.963 0a1.212 1.212 0 01.887.374 1.212 1.212 0 01.374.887 1.212 1.212 0 01-.374.887L6.805 12.193a1.2 1.2 0 01-.876.374 1.2 1.2 0 01-.876-.374L.363 7.5A1.176 1.176 0 010 6.613a1.25 1.25 0 01.384-.887 1.212 1.212 0 01.887-.374 1.212 1.212 0 01.887.374z",
  fill: "#25358e"
})));
export default __webpack_public_path__ + "static/icon-done.0b9194c0d85e11cd09e76a40541fcf57.svg";
export { SvgIconDone as ReactComponent };